var S = /* @__PURE__ */ ((r) => (r.INFO = "info", r.ERROR = "error", r.SUCCESS = "success", r))(S || {});
export {
  S as RocheUIMessageType
};
